import { getArticlesFromApi, getArticlesFromCms } from 'application/adapters/cms/articlesAdapter';

export interface ArticlesQuery {
	rootId?: number;
	limit?: number;
	offset?: number;
	preview?: boolean;
	previewData?: Content.PreviewData;
}

export const getArticles = async (query: ArticlesQuery): Promise<Articles.Article[]> => {
	if (typeof window === 'undefined') {
		//Server side
		return await getArticlesFromCms(query.rootId, query.limit, query.offset, query.preview, query.previewData);
	} else {
		//Client side
		return await getArticlesFromApi(query.rootId, query.limit, query.offset, query.preview, query.previewData);
	}
};
